function calculateScrollbarWidth() {
  const container = $('main').find('.container').outerWidth();
  $('html').attr(
    'style',
    '--scrollbar-width: ' +
      (window.innerWidth - document.body.clientWidth) +
      'px; --container-width: ' +
      container +
      'px;',
  );
}

$(document).ready(function () {
  calculateScrollbarWidth();
});

$(window).resize(function () {
  calculateScrollbarWidth();
});
